import _ from "underscore";
import { renderTemplate } from 'util/template_renderer'
import conditionSetTpl from "workflow/condition_builder/conditions/condition_set.hbs";
import conditionSummaryTpl from "workflow/condition_builder/summary/condition_summary.hbs";

export function updateConditionSetSummary($conditionSet, conditionCount, requireAll) {
    const $summary = $conditionSet.children(".condition_set_summary");

    let summary;
    if (conditionCount == 1) {
        summary = "When this condition is met:";
    } else if (requireAll) {
        summary = `When all ${conditionCount} of these conditions are met:`;
    } else {
        summary = `When any of these ${conditionCount} conditions are met:`;
    }

    if (conditionCount >= 1) {
        $summary.html(summary);
    } else {
        $summary.html("");
    }
}

export function getConditionSummary(condition, operator, actionStatusList, formDef) {
    let summary = `Summary not implemented yet for ${condition.type}`;

    if (!formDef) formDef = {};

    // Each condition has a different summary
    if (condition.type == "custom") {
        const left = `${condition.left}`,
            right = `${condition.right}`;

        summary = `<b>${left}</b> ${_opPrettyName(condition.operator)} <b>${right}</b>`;
    } else if (condition.type == "day_time_restrictions") {
        const inverse = `${condition.inverted ? "is not": "is"}`;

        let start = "", end = "";
        if (condition.time_restrict_start) {
            start = `from <b>${condition.time_restrict_start.substring(0, 5)}</b>`;
        }
        if (condition.time_restrict_end) {
            end = `until <b>${condition.time_restrict_end.substring(0, 5)}</b>`;
        }

        const dayMapping = {
                mon: "Mon",
                tue: "Tue",
                wed: "Wed",
                thu: "Thur",
                fri: "Fri",
                sat: "Sat",
                sun: "Sun"
            };

        let selectedDays = "";
        _.each(dayMapping, (value, key) => {
            if (condition[key]) {
                if (_.isEmpty(selectedDays)) {
                    selectedDays = `${selectedDays} ${value}`;
                } else {
                    selectedDays = `${selectedDays}, ${value}`;
                }
            }
        });
        summary = `${inverse} <b>${selectedDays}</b> ${start} ${end}`;
    } else if (condition.type == "reply_match") {
        summary = `Reply contains <b>${condition.value}</b>`;
    } else if (condition.type == "score_within_limits") {
        if (condition.min_total_score >= 0) {
            summary = `Form score is greater than <b>${condition.min_total_score}</b>`;
        } else if (condition.max_total_score >= 0) {
            summary = `Form score is less than <b>${condition.max_total_score}</b>`;
        } else if (condition.equal_total_score >= 0) {
            summary = `Form score is equal to <b>${condition.equal_total_score}</b>`;
        }
    } else if (condition.type == "action_status_match") {
        const imageData = _.findWhere(actionStatusList, {key:  condition.value});
        if (imageData) {
            const img = imageData.custom_image_data ? `background-image: url(${imageData.custom_image_data})` : "",
                div = `<div class="workflow_status_${condition.value} ml-1 mr-1 workflow_action_status_option_display" style="${img}"></div>`;
            summary = `The current status of the workflow is ${div}`;
        } else {
            summary = "The current status of the workflow is ?";
        }
    } else if (["form", "execution_submission_value_matches"].includes(condition.type)) {
        summary = _getFormSummary(condition, formDef);
    }

    if (operator) {
        // Display AND/OR at the end of the summary
        summary = `${summary} ${operator}`;
    }

    return summary;
}

export function refreshPreconditionSummary($container, preconditionSet, idx, type, actionUuid, formDef, actionStatusList, forExecution) {
    const id = type ? `${type}_${idx}` : null,
        $createCondBtn = $container.children(".create_conditions_btn"),
        $conditionWarning = $container.prev(".condition_warning");

    $conditionWarning.hide();

    if (!_.isEmpty(preconditionSet)) {
        // Clear the summary, hide create button, and add the new summary
        const templateData = {summaryView: true, isOdd: true, isRoot: true, id: id, idx: idx, type: type, action_uuid: actionUuid, forExecution: forExecution},
            $conditionSetTpl = renderTemplate(conditionSetTpl, templateData),
            $appendToEl = $conditionSetTpl.children(".condition_set");

        _appendConditionSummaryToSet(preconditionSet.conditions, $appendToEl, preconditionSet.require_all, true, formDef, actionStatusList);

        // Update summary text
        updateConditionSetSummary(
            $appendToEl,
            preconditionSet.conditions?.length || 0,
            preconditionSet.require_all
        );

        $container.html($createCondBtn);
        $createCondBtn.hide();
        $container.append($conditionSetTpl);
        if ($conditionSetTpl.find(".error").length) {
            $conditionWarning.show();
        }
    } else {
        // Remove the summary from the container, and show our create button again
        $container.html($createCondBtn);
        $createCondBtn.show();
    }
}

function _appendConditionSummaryToSet(conditionList, $appendToEl, requireAll, isOdd, formDef, actionStatusList) {
    const showConditionOperator = conditionList?.length > 1;

    let operator;
    if (showConditionOperator && conditionList?.length > 1) {
        operator = requireAll ? "AND" : "OR";
        operator = `<i>${operator}</i>`;
    }

    _.each(conditionList, condition => {
        let $conditionTpl;
        // Check if condition is a set of conditions or a single condition
        if (condition.type == "condition_set") {
            $conditionTpl = _getConditionSetSummaryTpl(condition, !isOdd, formDef, actionStatusList);
            // Append our condition
            $appendToEl.append($conditionTpl);
            // Add AND/0R divider if this isn't the last condition
            if (condition !== _.last(conditionList)) {
                $appendToEl.append(`<div class="operator mt-1"><span>${operator}</span></div>`);
            }
            // Update summary text
            updateConditionSetSummary(
                $conditionTpl.children(".condition_set"),
                condition.conditions?.length || 0,
                condition.require_all
            );
        } else {
            if (condition === _.last(conditionList)) {
                // Hide AND/OR for the last condition in a set
                operator = "";
            }

            const summary = getConditionSummary(condition, operator, actionStatusList, formDef);
            $conditionTpl = renderTemplate(conditionSummaryTpl, {summary: summary, is_met: condition.isMet, is_evaluated: condition.isEvaluated});

            // Append our condition
            $appendToEl.append($conditionTpl);
        }
    });
}

function _getConditionSetSummaryTpl(conditionSet, isOdd, formDef, actionStatusList, forExecution) {
    const $template = renderTemplate(conditionSetTpl, {summaryView: true, isOdd: isOdd, forExecution: forExecution, is_met: conditionSet.isMet, is_evaluated: conditionSet.isEvaluated}),
        $appendToEl = $template.children(".condition_set");

    _appendConditionSummaryToSet(conditionSet.conditions, $appendToEl, conditionSet.require_all, isOdd, formDef, actionStatusList);

    return $template;
}

function _getFormSummary(condition, formDef) {
    let summary = "";
    _.each(condition.value, (answer, fieldId) => {
        const field = _.findWhere(formDef.fields, {id: parseInt(fieldId)});

        if (!field) {
            summary = `<div class="color-error error italic pr-1">This form condition is no longer available</div>`;
            return;
        }

        let answerIds = answer;
        if (!Array.isArray(answer)) {
            answerIds = [answer];
        }

        const answers = _.filter(field.options, answer => _.contains(answerIds, answer.id)) || [],
            negate = condition.negate ? " not" : "",
            requireAll = condition.require_all ? `is${negate}` : `is${negate} one of`;

        if (_.isEmpty(answers) || answerIds.length > answers.length) {
            summary = `<div class="color-error error italic pr-1">${field.label} is missing an answer</div>`;
        } else {
            summary = `<b>${field.label}</b> ${requireAll} `;
            _.each(answers, answer => {
                if (answer == _.first(answers)) {
                    summary = `${summary} <b>${answer.label}</b>`;
                } else {
                    summary = `${summary}, <b>${answer.label}</b>`;
                }
            });
        }
    });
    return summary;
}

function _opPrettyName(op) {
    switch(op){
        case "eq":
            return "equals";
        case "ne":
            return "not equal to";
        case "lt":
            return "less than";
        case "lte":
            return "less than or equal to";
        case "gt":
            return "greater than";
        case "gte":
            return "greater than or equal to";
        default:
            return op;
    }
}